import React from 'react'
import { observer } from 'mobx-react-lite'

import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import ListItemText from '@mui/material/ListItemText'

import { CategoryIcon, Icon } from '@mxenabled/mxui'

import { Dialog, useGlobalCopyStore } from '../../../common'
import { type DetailedCategory } from '../../../core'

import { BudgetAmount } from '../shared/BudgetAmount'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

interface UnbudgetedRowProps {
  category: DetailedCategory
  onAddBudget: (category: DetailedCategory, amount: number) => void
}

export const UnbudgetedRow: React.FC<UnbudgetedRowProps> = observer(({ category, onAddBudget }) => {
  const { budgets: copy, common: commonCopy } = useGlobalCopyStore()

  const [isAddBudgetOpen, setIsAddBudgetOpen] = React.useState(false)
  const [amount, setAmount] = React.useState(
    `${category.totalAmount === 0 ? '' : category.totalAmount}`,
  )

  return (
    <React.Fragment>
      <ListItem key={category.guid}>
        <ListItemButton onClick={() => setIsAddBudgetOpen(true)}>
          <ListItemAvatar>
            <CategoryIcon categoryGuid={category.guid} />
          </ListItemAvatar>
          <ListItemText
            primary={category.name}
            secondary={formatCurrency(category.totalAmount, '0,0')}
          />
          <ListItemSecondaryAction>
            <Icon name="add" size={20} />
          </ListItemSecondaryAction>
        </ListItemButton>
      </ListItem>
      <Dialog
        copy={{ close_aria: commonCopy.close_aria, title: copy.add_title }}
        disablePrimaryButton={Number(amount) <= 0}
        isOpen={isAddBudgetOpen}
        onClose={() => setIsAddBudgetOpen(false)}
        onPrimaryAction={() => onAddBudget(category, Number(amount))}
        primaryText={copy.add_save_button}
      >
        <BudgetAmount amount={amount} categoryName={category.name} onAmountChanged={setAmount} />
      </Dialog>
    </React.Fragment>
  )
})
